import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';

import PageLoading from '../components/PageLoading';
import Dialog from 'material-ui/Dialog';
import SelectHomeLocation from '../components/SelectHomeLocation';
import MachineList from '../components/MachineList';
import RoleChecker from '../components/RoleChecker';

const formStyle = {
  marginLeft: 16
};

export default
@observer class NewUserPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  // Helper method that writes values back to datamodel as fields are changed
  handleValue(event) {
    var field = event.target.dataset.propname;
    var value = event.target.value;
    if(field=='id') value = value.toLowerCase()
    AppModel.newUserForm.user[field]=value;
    // If the user is editing the user-id field
    if(field=='id' && value>"") {
      console.log(AppModel.newUserForm);
      AppModelUtils.checkUsernameAvailability(AppModel.newUserForm);
    }
    if(field=='email' && AppModel.newUserForm.user.validEmail ) {
      AppModelUtils.checkIfEmailIsUnique(AppModel.newUserForm);
    }

  }

  insertNewUser() {
    AppModelUtils.registerNewUser()
    .then(()=> {
        this.context.router.goBack();
    })
    .catch(()=> {
        console.log("insert was rejected, staying on page");
    });
  }

  cancelInsert() {
    AppModel.newUserForm.reset();
    this.context.router.goBack();
  }

  resetInsertOperation() {
    // When server op failed and dialog box with error has been shown.
    AppModel.newUserForm.serverOperation.reset();
  }

  render() {
    var form = AppModel.newUserForm;
    var user = form.user;
    var operation = form.serverOperation;
    var showFailDialog = ("FAIL"==operation.result);
    const actions = [
      <FlatButton
        label={uiMsg('OK',"OK")}
        primary={true}
        onTouchTap={this.resetInsertOperation} />,
    ];
    return (
      <PageLoading loading={operation.waiting ||
                            AppModel.fetchingUserList ||
                            AppModel.fetchingGrantableRoles }>
        <Dialog
          title={uiMsg('SERVER_FAILED',"Server operation failed")}
          actions={actions}
          modal={true}
          open={showFailDialog}>
          {operation.message}
        </Dialog>
        <List><Subheader>{uiMsg('NU_USER_ID',"User identity")}</Subheader>
        <div style={formStyle}>
          <TextField  data-propname="name"
                      floatingLabelText={uiMsg('NU_FULL_NAME',"Full name")}
                      hintText={uiMsg('NU_FULL_NAME_HINT',"Full name of user.")}
                      fullWidth={true}
                      value={user.name || ""}
                      onChange={this.handleValue}
            />
          <TextField  data-propname="id"
                      floatingLabelText={uiMsg('NU_USERNAME',"Username")}
                      hintText={uiMsg('NU_USERNAME_HINT',"The username for logging into disinfection machine.")}
                      value={user.id || ""}
                      onChange={this.handleValue}
                      fullWidth={true}
                      errorText={user.login_unique || !user.id ? ""
                        : uiMsg('NU_USERNAME_TAKEN',"Username already taken, pick another") } />
          <TextField  data-propname="email"
                      floatingLabelText={uiMsg('NU_EMAIL',"Email (used to log in from web)")}
                      hintText={uiMsg('NU_EMAIL_HINT',"Email used for login.")}
                      fullWidth={true}
                      value={user.email || ""}
                      onChange={this.handleValue}
                      errorText={
                        !user.email ? null : (
                          !user.validEmail ?
                          uiMsg('NU_INVALID_EMAIL',"Invalid email address") : (
                            user.email_checked && !user.email_unique ?
                              uiMsg('NU_EMAIL_TAKEN',"Address registered with existing user") : null
                          )
                        )
                       }
          />
          <TextField  data-propname="password"
                      floatingLabelText={uiMsg('NU_PASSWORD',"Password, to be communicated to user")}
                      hintText={uiMsg('NU_PASSWORD_HINT',"Password")}
                      fullWidth={true}
                      value={user.password || ""}
                      onChange={this.handleValue}
            />
          <SelectHomeLocation user={user} ></SelectHomeLocation>
        </div>
        </List>
        <RoleChecker form={form} ></RoleChecker>
        <Toolbar>
          <ToolbarGroup firstChild={true}></ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton
                    onTouchTap={this.cancelInsert.bind(this)}>
                    {form.isEmpty ? uiMsg('NU_CLOSE')
                    : uiMsg('NU_CANCEL')}
            </FlatButton>
            <RaisedButton primary
                          disabled = {!user.isValidNewUser}
                          onTouchTap={this.insertNewUser.bind(this)}>Add
            </RaisedButton>
          </ToolbarGroup>
        </Toolbar>
      </PageLoading>
    )
  }


};



/** WEBPACK FOOTER **
 ** ./src/pages/NewUserPage.jsx
 **/